import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Lobby from './routes/Lobby/Lobby';
import ConfirmationPage from './routes/Confirmation/ConfirmationPage';
import AnalyzeRequest from './routes/AnalyzeRequest/AnalyzeRequest';
import ProductPage from './routes/Product/ProductPage';
import { CartProvider } from './contexts/CartContext';
import { BackButtonProvider } from './contexts/BackButtonContext';
import Checkout from './routes/Checkout/Checkout';
import ConfirmationPageOrder from './routes/Confirmation/ConfirmationPageOrder';
import Orders from './routes/Orders/Orders';
import Order from './routes/Order/Order';
import { ToastProvider } from './contexts/ToastContext';
import { CurrencyProvider } from './contexts/CurrencyContext';
import { UserProvider } from './contexts/UserContext';
import ProfilePage from './routes/Profile/Profile';

const AppRouter = () => {
  return (
    <Router>
      <BackButtonProvider>
        <ToastProvider>
          <UserProvider>
            <CurrencyProvider>
              <CartProvider>
                  <Routes>
                    <Route path="/" element={<Lobby />} />
                    <Route path="/success" element={<ConfirmationPage />} />
                    <Route path="/success/order" element={<ConfirmationPageOrder />} />
                    <Route path="/request" element={<AnalyzeRequest />} />
                    <Route path="/product/:id" element={<ProductPage />} />
                    <Route path="/checkout" element={<Checkout />} />
                    <Route path="/orders" element={<Orders />} />
                    <Route path="/order/:id" element={<Order />} />
                    <Route path="/profile" element={<ProfilePage />} />
                  </Routes>
              </CartProvider>
            </CurrencyProvider>
          </UserProvider>
        </ToastProvider>
      </BackButtonProvider>
    </Router>
  );
};

export default AppRouter;